'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    async getAdvances(id) {
        const data = {
            method: 'get',
            url: 'casual-advances/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createAdvance(json) {
        const data = {
            method: 'post',
            url: 'casual-advance',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Advance created successfully')
            return true;
        }
    },
    async updateAdvance(json, id) {
        const data = {
            method: 'patch',
            url: 'casual-advance/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Advance updated successfully')
            return true;
        }
    },
    async deleteAdvance(id) {
        const data = {
            method: 'delete',
            url: 'casual-advance/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Advance deleted successfully')
            return true;
        }
    },
}
